module.exports = __webpack_public_path__ + "assets/img/svg-.4ed10d62.png";